var _ = (v, p, t) => new Promise((d, i) => {
  var r = (o) => {
    try {
      a(t.next(o));
    } catch (e) {
      i(e);
    }
  }, c = (o) => {
    try {
      a(t.throw(o));
    } catch (e) {
      i(e);
    }
  }, a = (o) => o.done ? d(o.value) : Promise.resolve(o.value).then(r, c);
  a((t = t.apply(v, p)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { checkMenuPermissionSync as j } from "@oppein/op-utils";
import T from "../approval-table/indexTableItem.vue.js";
import R from "../mall-sp-approval-trigger/index.ce.vue.js";
import { defineComponent as k, useTemplateRef as g, onMounted as x, computed as B, openBlock as M, createElementBlock as z, createElementVNode as V, createVNode as n, withCtx as m, Fragment as E } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as L } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as l, unref as f } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import O from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import P from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import F from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Y = /* @__PURE__ */ k({
  __name: "relatedApproval.ce",
  emits: ["submit"],
  setup(v, { expose: p, emit: t }) {
    const d = g("relatedApprovalContainer"), i = g("triggerRef");
    L();
    const r = l(!1), c = l([]), a = l(!0);
    l(0), l([]);
    const o = l(!1), e = l({
      pageSize: 10,
      pageNum: 1,
      applyTypeList: ["bpm_process_djjspecial_judge"],
      businessType: "business_serviceNo",
      status: "pass",
      businessId: "",
      isCreatorId: void 0,
      orderId: ""
    });
    x(() => _(this, null, function* () {
    }));
    const I = B(() => e.value.orderId && j({ permission: "initGenSpTrial" }));
    let u = null;
    function S(s) {
      c.value = [], s.selectMode === "Single" ? a.value = !0 : a.value = !1, e.value.businessId = s.businessId || "", e.value.isCreatorId = s.isCreatorId, e.value.orderId = s.orderId || "", a.value = !0, r.value = !0;
    }
    const A = () => {
      r.value = !1, u = null, e.value = {
        pageSize: 10,
        pageNum: 1,
        applyTypeList: ["bpm_process_djjspecial_judge"],
        businessType: "business_serviceNo",
        status: "pass",
        businessId: "",
        isCreatorId: void 0,
        orderId: ""
      };
    }, h = () => {
      var s;
      (s = i.value) == null || s.open({
        code: "bpm_process_djjspecial_judge",
        serviceId: e.value.businessId || "",
        disabledOptions: !0,
        disabledSearch: !0,
        isRelationOrder: 1,
        isTable: 0,
        orderId: e.value.orderId || ""
      });
    }, y = (s) => {
      console.log("submit", s), r.value = !1, w("submit", s);
    }, w = t, C = () => {
      r.value = !1, u && (u([]), u = null);
    };
    return p({ open: S }), (s, b) => (M(), z(E, null, [
      V("div", {
        ref_key: "relatedApprovalContainer",
        ref: d
      }, null, 512),
      n(f(F), {
        bordered: "",
        show: r.value,
        "onUpdate:show": b[0] || (b[0] = (N) => r.value = N),
        "mask-closable": !1,
        "z-index": 9999,
        to: d.value || "body"
      }, {
        default: m(() => [
          n(f(O), { show: o.value }, {
            default: m(() => [
              n(f(P), {
                style: { width: "1300px" },
                title: "关联已审批单据",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: A
              }, {
                default: m(() => [
                  n(T, {
                    ref: "approvalTableRef",
                    onSubmit: y,
                    onCancal: C,
                    businessId: e.value.businessId,
                    isShowAddApprovalButton: !!I.value,
                    onAddApproval: h
                  }, null, 8, ["businessId", "isShowAddApprovalButton"]),
                  n(R, {
                    ref_key: "triggerRef",
                    ref: i
                  }, null, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  Y as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/related-approval/relatedApproval.ce.vue.js
// module id = 1286
// module chunks = 41